import axios from "axios";
import { API_URL } from "../variables";

export const FETCH_POPUPS_REQUEST = "FETCH_POPUPS_REQUEST";
export const FETCH_POPUPS_SUCCESS = "FETCH_POPUPS_SUCCESS";
export const FETCH_POPUPS_FAILURE = "FETCH_POPUPS_FAILURE";

export const fetchActivePopups = () => async (dispatch) => {
  dispatch({ type: FETCH_POPUPS_REQUEST });

  try {
    const response = await axios.get(`${API_URL}/api/users/popups/get-active`);
    dispatch({
      type: FETCH_POPUPS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_POPUPS_FAILURE,
      payload: error.message,
    });
  }
};

